export enum Language {
    English = "en",
    Vietnamese = "vi",
}

export enum IconSize {
    sm = "sm",
    md = "md",
    lg = "lg",
    xl = "xl",
}

export enum Mode {
    Create = 0,
    Update = 1,
    View = 2,
}

export enum Permission {
    Read = 32768, // Xem
    ListOrExport = 16384, // Xem danh sách, xuất file (mở rộng của quyền đọc)
    Create = 8192, // Tạo
    BulkCreateOrImport = 4096, // Tạo nhiều hoặc import file (mở rộng của quyền tạo)
    Update = 2048, // Cập nhật
    BulkUpdate = 1024, // Cập nhật nhiều (mở rộng của cập nhật)
    Delete = 512, // Xóa
    BulkDelete = 256, // Xóa nhiều (mở rộng của xóa)
    None = 0,
}

export enum Status {
    Deleted = -9,
    PendingInvitation = -3,
    Blocked = -2,
    Draft = -1,
    Inactive = 0,
    Active = 1,
    Accept = 2,
    Decline = 3,
}

export enum MultipleApply {
    False = 0,
    True = 1,
}

export enum RoleType {
    // 16 bit đầu là bộ quyền (bỏ bit dấu)
    Service = 32768,
    TenantOrMembership = 16384, // RoleType == TenantOrMembership thì là membership
    Normal = 8192, // Bộ quyền hệ thống
    User = 4096, // Bộ quyền người dùng cuối. Hiện tại dùng để xác định quyền khi đăng ký vào dịch vụ và custom đặc biệt không sử dụng tổ chức

    // 8 bit đầu dùng phân loại, xếp theo thứ bậc
    Owner = 256,
    Admin = 128,
    GroupAdmin = 64,
    Member = 32,
    Custom = 16,
    Default = 1,
}

export enum RoleLevel {
    SuperAdmin = 0,
    ServiceAdmin = 1,
    Default = 100,
    Owner = 101,
    Admin = 500,
    GroupAdmin = 1000,
    Member = 1500,
    ServiceRole = 2000,
    Custom = 3000,
    Membership = 5000,
}

export enum ResourceType {
    Controller = 0,
    Module = 1,
    Service = 2,
}

export enum AccessMode {
    Public = 0,
    Private = 1,
    Internal = 2,
    PrivateRBAC = 4,
}

export enum CodeNameCommon {
    USER_TITLE = "CD",
}

export enum InvitationDetailType {
    Resource,
    Role,
    Group,
}

export enum ActionRequest {
    Create = 0,
    Update = 1,
    Delete = -1,
    Empty = -2,
    Detail = -33,
}

export enum GroupUserDefault {
    None = 1,
    Default = 2,
}

export enum IsTrue {
    False = 0,
    True = 1,
}

export enum GroupType {
    Company = 0,
    Department = 1,
    BranchStore = 2,
    Membership = 64,
    Other = 127,
}

export enum Gender {
    Male = 1,
    Female = 2,
    Other = 3,
}

export enum FileAccessMode {
    Public = 0,
    Authenticated = 1,
    Internal = 2,
    Private = 4,
}

export enum FileEncrypted {
    None = 0,
    Encrypting = 1,
    Encrypted = 2,
}

export enum FileProcessingStatus {
    Unprocessed = 0,
    Processing = 1,
    Processed = 2,
}

export enum ServiceOrganizationAction {
    Create = 0,
    Update = 1,
    Delete = -1,
}

export enum StudentListMode {
    Active = "active",
    Pending = "pending",
}

export enum OrganizationType {
    Normal = 0,
    Main = 1,
}

export enum ActionTypeSelectBox {
    Delete = -9,
    Submit = 9,
    Cancel = 99,
}

export type RoleTableMode = "normal" | "advance";

export enum AdminFeature {
    None = 0,
    AdminFeature = 1,
}

export enum AvailableLanguage {
    Vietnamese = "vi",
    English = "en",
}

export enum PolicyRequirementType {
    Role = 1,
    User = 2,
    Group = 4,
    OtherClaim = 8,
}

export enum PolicyRequirementCompareType {
    Equal = 1,
    NotEqual = 2,
    LessThan = 3,
    GreaterThan = 4,
}

export enum RoleTab {
    Role = "role",
    Policy = "policy",
}

export enum GroupCompareType {
    Include = "in",
    NotInClude = "not-in"
}